import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Amplify from "aws-amplify";
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import awsconfig from './aws-exports'
import Vuelidate from 'vuelidate'
import { VueMaskDirective } from 'v-mask'
import Gravatar from 'vue-gravatar'
import { AppConfig } from "./classes/AppConfig";

Amplify.configure(awsconfig);

Vue.component('v-gravatar', Gravatar);

Vue.config.productionTip = false;

Vue.use(Vuelidate);

Vue.directive('mask', VueMaskDirective)

Vue.use(require('vue-moment'));

Vue.filter("capitalize", function (value) {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.prototype.appConfig = AppConfig

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");

// Let's style this up
require("./assets/style.css");